import { useTheme } from '@mui/material'

import { Types } from 'service-api'
import { RequestIcon } from '../asset/request_icon'
import { ScheduleIcon } from '../asset/schedule_icon'
import { ColorChip } from '../color_chip/color_chip'
import { i18WithParams as t } from '../shared/locales'
import { getInvoiceSubStatus } from '@shared/invoices'

export const InvoiceStatusChip = ({ invoice }: { invoice: Types.InvoiceAdminDto | Types.InvoiceClientDto }) => {
  const theme = useTheme()
  const subStatusI18 = invoice?.invoiceSubStatus?.toLowerCase() || ''
  let label = t(`global.label.invoiceSubStatus.${subStatusI18}`)
  const invoiceSubStatus = getInvoiceSubStatus(invoice)

  const statusProps = (() => {
    if (invoiceSubStatus.isRequested) {
      label = t('global.label.invoiceSubStatus.requested')
      return {
        textColor: theme.palette.error.darken60,
        bgColor: theme.palette.error.shade12,
        icon: <RequestIcon viewBox="-4 -2 24 27" fill={theme.palette.warning.main} />,
      }
    } else if (invoiceSubStatus.isScheduled) {
      return {
        textColor: theme.palette.info.darken60,
        bgColor: theme.palette.info.shade10,
        icon: <ScheduleIcon viewBox="-4 -3 24 28" fill={theme.palette.info.dark} />,
      }
    } else if (invoiceSubStatus.isDeclined || invoiceSubStatus.isCanceled) {
      return {
        textColor: theme.palette.error.darken60,
        bgColor: theme.palette.error.shade12,
      }
    } else if (invoiceSubStatus.isCheckedOut) {
      return {
        textColor: theme.palette.text.primary,
        bgColor: theme.palette.action.selected,
      }
    } else if (invoiceSubStatus.isPending) {
      return {
        textColor: theme.palette.success.darken60,
        bgColor: theme.palette.success.shade12,
      }
    } else {
      return {
        textColor: theme.palette.warning.darken60,
        bgColor: theme.palette.warning.shade12,
        icon: <RequestIcon viewBox="-4 -2 24 27" fill={theme.palette.warning.main} />,
      }
    }
  })()

  return (
    <ColorChip
      label={label.toUpperCase()}
      sxOverrides={{ fontWeight: 'bold', borderRadius: 1, pt: 0.25 }}
      {...statusProps}
    />
  )
}
